'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _require = require('../utils/constants'),
    NOT_FOUND = _require.NOT_FOUND;

var BaseStorage = require('../base-storage');
var LocalStorageStrategy = require('./local-storage');
var DELETED = '___DELETED___';

var CachedStorageStrategy = function (_BaseStorage) {
  _inherits(CachedStorageStrategy, _BaseStorage);

  function CachedStorageStrategy(_ref) {
    var remoteStrategy = _ref.remoteStrategy,
        _ref$localStrategy = _ref.localStrategy,
        localStrategy = _ref$localStrategy === undefined ? new LocalStorageStrategy() : _ref$localStrategy;

    _classCallCheck(this, CachedStorageStrategy);

    var _this = _possibleConstructorReturn(this, (CachedStorageStrategy.__proto__ || Object.getPrototypeOf(CachedStorageStrategy)).call(this));

    _this.remoteStrategy = BaseStorage.verify(remoteStrategy);
    _this.localStrategy = BaseStorage.verify(localStrategy);
    return _this;
  }

  _createClass(CachedStorageStrategy, [{
    key: '_cacheItem',
    value: function _cacheItem(key, value, options) {
      return this.localStrategy.setItem(key, value, Object.assign(options, { expiration: 3600 }));
    }
  }, {
    key: 'setItem',
    value: function setItem(key, value, options) {
      var _this2 = this;

      return this.remoteStrategy.setItem(key, value, options).then(function () {
        return _this2._cacheItem(key, value, options);
      });
    }
  }, {
    key: 'removeItem',
    value: function removeItem(key, options) {
      var _this3 = this;

      return this.remoteStrategy.removeItem(key, options).then(function () {
        return _this3._cacheItem(key, DELETED, options);
      });
    }
  }, {
    key: '_getRemoteAndCache',
    value: function _getRemoteAndCache(key, options) {
      var _this4 = this;

      return this.remoteStrategy.getItem(key, options).then(function (value) {
        return _this4._cacheItem(key, value, options).then(function () {
          return value;
        });
      }).catch(function (e) {
        if (e === NOT_FOUND) {
          return _this4._cacheItem(key, DELETED, options).then(function () {
            throw e;
          });
        }
        throw e;
      });
    }
  }, {
    key: 'getItem',
    value: function getItem(key, options) {
      var _this5 = this;

      function throwIfDeletedOrReturn(value) {
        if (value === DELETED) {
          throw NOT_FOUND;
        }

        return value;
      }

      return this.localStrategy.getItem(key, options).catch(function () {
        return _this5._getRemoteAndCache(key, options);
      }).then(throwIfDeletedOrReturn);
    }
  }, {
    key: 'getAllItems',
    value: function getAllItems(options) {
      var _this6 = this;

      return this.remoteStrategy.getAllItems(options).then(function (items) {
        return Promise.all(Object.keys(items).map(function (key) {
          return _this6._cacheItem(key, items[key], options);
        })).then(function () {
          return items;
        });
      });
    }
  }]);

  return CachedStorageStrategy;
}(BaseStorage);

module.exports = CachedStorageStrategy;